export default __webpack_public_path__ + "static/media/Maus.d986cf0b.png";